<template>
  <div
      class="menu-w menu-position-side menu-side-left menu-layout-full sub-menu-style-inside sub-menu-color-bright selected-menu-color-light menu-activated-on-click menu-has-selected-link">

    <div class="logo-w">
      <router-link class="logo" to="/dashboard/info">
        <img :src="companyLogo" class="w-100"/>
      </router-link>
    </div>

    <div class="logged-user-w avatar-inline">
      <div class="logged-user-i" style="padding-left: 0!important;">
        <div class="logged-user-info-w">
          <div v-if="piniaCurrentUser?.id">
            <div class="logged-user-name">
              {{ piniaCurrentUser?.firstName + ' ' + piniaCurrentUser?.lastName }}
            </div>
            <div class="logged-user-role">
              {{ piniaCurrentUser?.userAccessRightsTranslation }}
            </div>
          </div>
        </div>
        <div class="logged-user-toggler-arrow">
          <div class="os-icon os-icon-chevron-down"></div>
        </div>
        <div class="logged-user-menu color-style-bright">
          <div class="logged-user-avatar-info">
            <router-link :to="{ name: 'userProfile' }" class="d-flex align-items-center">
              <div class="avatar-w me-2">
                <img alt="" src="../../assets/img/user.jpg">
              </div>
            </router-link>

            <router-link :to="{ name: 'userProfile' }" class="d-flex align-items-center">
              <div class="logged-user-info-w">
                <div class="logged-user-name">
                  {{ piniaCurrentUser.firstName }} {{ piniaCurrentUser.lastName }}
                </div>
                <div class="logged-user-role">
                  {{ piniaCurrentUser.userAccessRightsTranslation }}
                </div>
              </div>
            </router-link>
          </div>


          <div class="bg-icon">
            <i class="os-icon os-icon-wallet-loaded"></i>
          </div>
          <ul>
            <li>
              <a href="#" @click="handleLogout">
                <i class="os-icon os-icon-signs-11"></i>
                <span>Logout</span>
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'changePassword' }">
                <i class="os-icon os-icon-signs-11"></i>
                <span>{{ $t('general.button.change_password') }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="menu-actions" v-if="isLoaded">
      <!-- FOR COORDINATORS -->
      <div class="d-flex" v-if="
            currentUserRole === 'ROLE_ADMIN' ||
            currentUserRole === 'ROLE_PERSONAL' ||
            currentUserRole === 'ROLE_HEAD_OF_HR' ||
            currentUserRole === 'ROLE_SITE_MANAGER' ||
            currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
            currentUserRole === 'ROLE_HEAD_OF_MARKETING' ||
            currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
            currentUserRole === 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY'">

        <!-- Travel expenses -->
        <router-link
            v-if="companySettings.travelExpensesEnabled"
            :to="{ name: 'travelExpensesPendingAndActiveListForCoordinator' }">
          <div class="messages-notifications">
            <i
                class="fas fa-car-side car-icon"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
                data-title="Fahrtkosten"
                data-bs-toggle="tooltip"
                data-bs-placement="top">
            </i>
            <div v-if="countTravelExpensesNotification > 0"
                 class="new-messages-count">
              !
            </div>
          </div>
        </router-link>

        <!-- Private coaching inquiry -->
        <router-link :to="{ name: 'privateCoachingInquiryOverviewListForCoach' }">
          <div class="messages-notifications" style="margin:0">
            <i
                class="fa-solid fa-file-lines"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-title="Anfrage"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }">
            </i>
            <div v-if="countInquiryNotificationForCoach > 0"
                 class="new-messages-count" style="color: white">
              {{ countInquiryNotificationForCoach }}
            </div>
          </div>
        </router-link>
      </div>


      <!-- TRAVEL EXPENSES FOR NON COORDINATORS -->
      <div class="d-flex" v-if="
            companySettings.travelExpensesEnabled &&
            currentUserEngagementType === 'intern' &&
            currentUserRole !== 'ROLE_ADMIN' &&
            currentUserRole !== 'ROLE_PERSONAL' &&
            currentUserRole !== 'ROLE_HEAD_OF_HR' &&
            currentUserRole !== 'ROLE_SITE_MANAGER' &&
            currentUserRole !== 'ROLE_HEAD_OF_AMDL' &&
            currentUserRole !== 'ROLE_HEAD_OF_MARKETING' &&
            currentUserRole !== 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' &&
            currentUserRole !== 'ROLE_HEAD_OF_OCCUPATIONAL_THERAPY'">

        <!-- Travel expenses -->
        <router-link :to="{ name: 'travelExpensesPendingAndActiveList' }">
          <div class="messages-notifications">
            <i
                class="fas fa-car-side car-icon"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
                data-title="Fahrtkosten"
                data-bs-toggle="tooltip"
                data-bs-placement="top">
            </i>
            <div v-if="countTravelExpensesNotification > 0" class="new-messages-count">
              !
            </div>
          </div>
        </router-link>
      </div>


      <!-- ACTIONS FOR COACH ONLY -->
      <!-- Coach bill ( for external coordinators )-->
      <div class="d-flex"
           v-if="currentUserRole === 'ROLE_COACH' ||
            currentUserRole === 'ROLE_THERAPIST'">
        <router-link
            :to="{ name: 'coachBillingCoordinatorPendingBills' }"
            v-if="piniaCurrentUser.engagementType === 'extern'">
          <div class="messages-notifications">
            <i class="fas fa-bell"
               :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
               data-title="Rechnungen"
               data-toggle="tooltip">
            </i>
            <div v-if="countPendingBillsForExternalCoordinator > 0"
                 class="new-messages-count" style="color: white">
              {{ countPendingBillsForExternalCoordinator }}
            </div>
          </div>
        </router-link>

        <!-- Private coaching inquiry -->
        <router-link :to="{ name: 'privateCoachingInquiryOverviewListForCoach' }">
          <div class="messages-notifications" style="margin:0">
            <i
                class="fa-solid fa-file-lines"
                data-title="Anfrage"
                data-toggle="tooltip"
                :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }">
            </i>
            <div v-if="countInquiryNotificationForCoach > 0"
                 class="new-messages-count" style="color: white">
              {{ countInquiryNotificationForCoach }}
            </div>
          </div>
        </router-link>
      </div>

      <!-- FOR ACCOUNTANT -->
      <div class="d-flex" v-if="currentUserRole === 'ROLE_ACCOUNTANT'">
        <!-- Coach bill notifications -->
        <router-link :to="{
          name: 'coachBillingPendingBills',
          query: { withMessage: 1 }
        }">
          <div class="messages-notifications">
            <i class="fas fa-bell"
               :style="{ color: 'var(--primary)', fontSize: '25px', width: '40px' }"
               data-title="Rechnungen"
               data-toggle="tooltip">
            </i>
            <div v-if="countUnreadMessagesForAccountant > 0" class="new-messages-count">
              !
            </div>
          </div>
        </router-link>
      </div>

    </div>

    <ul class="main-menu">
      <div v-if="impersonating" class="mt-2 mb-4 w-100 text-center">
        <button @click="stopImpersonation()" class="btn btn-danger w-100"
                style="font-size: 13px; text-transform: uppercase">
          Exit impersonation
        </button>
      </div>

      <li v-for="(item) in menu" :class="{ 'has-sub-menu': item.submenu }" :key="item.title">
        <a href="#">
          <div class="icon-w">
            <!-- CSS icon -->
            <div v-if="item.icon" :class="item.icon"></div>
          </div>
          <router-link class="text-white text-decoration-none w-100" :to="{ name: item.name }">
            <span class="pl-0">{{ item.title }}</span>
          </router-link>
        </a>
        <div v-if="item.submenu" class="sub-menu-w">
          <div class="sub-menu-i">
            <ul class="sub-menu">
              <li v-for="(subItem) in item.submenu" :key="subItem.title" class="nav-item active">
                <router-link class="nav-link" :to="{ name: subItem.name}">{{ subItem.title }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import securityService from '@/api/Security';
import {CloseToast} from '@/components/VueToast';
import router from '@/router';
import {formatRole} from '@/shared/functions';
import {getMenuLinks} from '@/shared/utils/MenuLinksUtils';
import {piniaUserStore} from '@/store/piniaUserStore';
import $ from 'jquery';
import {computed, defineProps, onMounted, toRefs} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaUserState = piniaUserStore();
const piniaCompanySettingsState = piniaCompanySettingsStore()
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = computed(() => piniaCurrentUser?.value?.roles[0]);

const companyLogo = computed(() => piniaCompanySettingsState.companySettings?.logoUrl);
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const currentUserEngagementType = piniaCurrentUser?.value?.engagementType;
const impersonating = computed(() => piniaUserState.currentUser.impersonating);

const props = defineProps({
  countTravelExpensesNotification: {
    type: Number,
    required: true,
    default: 0,
  },
  countPendingBillsForExternalCoordinator: {
    type: Number,
    required: true,
    default: 0,
  },
  countInquiryNotificationForCoach: {
    type: Number,
    required: true,
    default: 0,
  },
  countUnreadMessagesForAccountant: {
    type: Number,
    required: true,
  },
  isLoaded: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const countTravelExpensesNotification = toRefs(props)['countTravelExpensesNotification'];
const countPendingBillsForExternalCoordinator = toRefs(props)['countPendingBillsForExternalCoordinator'];
const countInquiryNotificationForCoach = toRefs(props)['countInquiryNotificationForCoach'];
const countUnreadMessagesForAccountant = toRefs(props)['countUnreadMessagesForAccountant'];
const isLoaded = toRefs(props)['isLoaded'];

function handleLogout() {
  localStorage.clear();
  window.location.reload();
  router.push({name: 'login'});
}

const menu = computed(() => {
  const currentUserRoles = piniaCurrentUser.value.roles;
  const currentUserEngagementType = piniaCurrentUser.value.engagementType;

  return getMenuLinks()
      .map(item => {
        const filteredSubmenu = item.submenu?.filter(subItem => {
          return (
              subItem.roles &&
              Array.isArray(subItem.roles) &&
              subItem.roles.some(role => currentUserRoles.includes(role))
          );
        });

        const hasTopLevelAccess =
            item.roles &&
            Array.isArray(item.roles) &&
            item.roles.some(role => currentUserRoles.includes(role));

        if (item.engagementTypes !== undefined) {
          const hasEngagementTypes =
              item.engagementTypes &&
              Array.isArray(item.engagementTypes) &&
              item.engagementTypes.some(role => role === currentUserEngagementType);

          if (!hasEngagementTypes) {
            return null;
          }
        }

        if (hasTopLevelAccess || (filteredSubmenu && filteredSubmenu.length)) {
          return {
            ...item,
            submenu: filteredSubmenu,
          };
        }

        return null;
      })
      .filter(item => item !== null);
});

const stopImpersonation = async () => {
  try {
    const {data} = await securityService.stopImpersonation();
    localStorage.setItem('token', data.data.token);
    await piniaUserState.piniaGetUser();

    countTravelExpensesNotification.value = 0;
    countPendingBillsForExternalCoordinator.value = 0;
    countInquiryNotificationForCoach.value = 0;

    await router.push({name: `dashboard-${formatRole(piniaCurrentUser.value.roles[0])}`});
    CloseToast();
  } catch (error) {
    console.error('Failed to stop impersonation:', error);
  }
};

onMounted(async () => {
  var menu_timer;
  $('.menu-activated-on-hover').on('mouseenter', 'ul.main-menu > li.has-sub-menu', function () {
    var $elem = $(this);
    clearTimeout(menu_timer);
    $elem.closest('ul').addClass('has-active').find('> li').removeClass('active');
    $elem.addClass('active');
  });
  $('.menu-activated-on-hover').on('mouseleave', 'ul.main-menu > li.has-sub-menu', function () {
    var $elem = $(this);
    menu_timer = setTimeout(function () {
      $elem.removeClass('active').closest('ul').removeClass('has-active');
    }, 30);
  }); // INIT MENU TO ACTIVATE ON CLICK

  $('.menu-activated-on-click').on('click', 'li.has-sub-menu > a', function () {
    var $elem = $(this).closest('li');

    if ($elem.hasClass('active')) {
      $elem.removeClass('active');
    } else {
      $elem.closest('ul').find('li.active').removeClass('active');
      $elem.addClass('active');
    }

    return false;
  });

  $('.menu-activated-on-click').on('click', 'li:not(.has-sub-menu) > a', function () {
    var $elem = $(this).closest('li');

    if ($elem.hasClass('active')) {
      $elem.removeClass('active');
    } else {
      $elem.closest('ul').find('li.active').removeClass('active');
      $elem.addClass('active');
    }
  });

});

</script>